export const IconEcoCart = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="20px" viewBox="0 0 21 16" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.88086 2.87939H18.247C18.939 2.87939 19.5 3.44036 19.5 4.13236C19.5 4.25079 19.4832 4.36863 19.4501 4.48235L17.4454 11.3736C17.2897 11.9087 16.7995 12.2766 16.2423 12.2766H8.555C7.9978 12.2766 7.50755 11.9087 7.35191 11.3736L4.88086 2.87939Z"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
        />
        <path d="M5.25889 4.1324L4.55622 1.87984C4.39295 1.35645 3.90836 1 3.3601 1H1.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        <path
            d="M8.5 16C9.05228 16 9.5 15.5523 9.5 15C9.5 14.4477 9.05228 14 8.5 14C7.94772 14 7.5 14.4477 7.5 15C7.5 15.5523 7.94772 16 8.5 16Z"
            fill="currentColor"
        />
        <path
            d="M16.5 16C17.0523 16 17.5 15.5523 17.5 15C17.5 14.4477 17.0523 14 16.5 14C15.9477 14 15.5 14.4477 15.5 15C15.5 15.5523 15.9477 16 16.5 16Z"
            fill="currentColor"
        />
        <path d="M9.89258 6.02332V9.15812" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
        <path d="M12.3984 6.02332V9.15812" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
        <path d="M14.9048 6.02332V9.15812" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
);
